// Entorno QA: apunta al stack de la suscripcion propia (RG `depilzone`) por el
// dominio propio auracentromedico.com. Los FQDN *.azurecontainerapps.io siguen
// respondiendo y estan permitidos en CORS, por si hace falta volver atras.
//
// Ojo con el prefijo de version: el Nest lo calcula en `main.ts` a partir de
// API_VERSION. En ese Container App API_VERSION=3.7.0, asi que el prefijo es
// `/v370` y va explicito aca, igual que `/v350` en el entorno de desarrollo.
export const environment = {
  production: false,

  apiNest: 'https://api.auracentromedico.com/v370',
  apiGraphql: 'https://api.auracentromedico.com/graphql',
  apiCsharp: 'https://core.auracentromedico.com',

  // Legacy: backend del template original. No corresponde a Policlinic.
  base_url: 'http://localhost:3000/api',

  // Mercado Pago: en QA va la Public Key de PRUEBA (TEST-...), nunca la de
  // produccion. Se completa desde el panel de Mercado Pago. Ver SPEC-018.
  mpPublicKey: 'TEST-3c535b1a-2383-4d98-b5c3-f91bf23e8b59',

  // Izipay (recarga de puntos/soles). Config publica del SDK. Ver SPEC-023.
  izipay: {
    merchantCode: '',
    merchantBuyerId: '',
    publicKey: 'RSA',
  },
  // PENDIENTE — no cargar todavía: la API de Google Maps cobra por uso (decisión del
  // 2026-09-21). Además está apagada en código (MAPA_HABILITADO en mapa-sedes.component).
  // Google Maps JavaScript API (mapa de sedes cercanas). Vacía = el mapa no se muestra y
  // queda la lista ordenada por distancia. Usar una clave PROPIA, restringida por referer
  // a auracentromedico.com y sólo a "Maps JavaScript API" (es pública: va al navegador).
  googleMapsApiKey: '',
};
